/**************
 Mega Menu
 ***************/
const menuTrigger = document.querySelector('.headerNavLink.menu');

if (menuTrigger) {
    const dropdownNav = document.querySelector('#dropdownNav');
    const dropdownItem = document.querySelector('.dropdownNavItem');
    const dropdownExit = document.querySelector('#dropdownExit');
    const tabs = Array.from(document.querySelectorAll('.dropdownNavItemControlsItem'));
    const panels = Array.from(document.querySelectorAll('.dropdownNavItemLinksGroup'));

    let menuCloseTimer = null;

    // open the dropdown and let keyboard users tab into its contents
    const openMenu = () => {
        clearTimeout(menuCloseTimer);
        menuTrigger.classList.add('active');
        dropdownItem.classList.add('active');
        dropdownExit.classList.add('active');
        menuTrigger.setAttribute('aria-expanded', 'true');
        dropdownNav.removeAttribute('inert');
    };

    // close the dropdown and pull it out of the tab order
    const closeMenu = () => {
        menuTrigger.classList.remove('active');
        dropdownItem.classList.remove('active');
        dropdownExit.classList.remove('active');
        menuTrigger.setAttribute('aria-expanded', 'false');
        dropdownNav.setAttribute('inert', '');
    };

    // switch which category tab + panel is active; only the active tab stays
    // in the tab order (roving tabindex), so Tab moves *out* of the tablist
    // into the SHOP ALL link and then the panel links
    const activateTab = (tab, focusTab = false) => {
        tabs.forEach(t => {
            t.classList.remove('active');
            t.setAttribute('aria-selected', 'false');
            t.setAttribute('aria-expanded', 'false');
            t.setAttribute('tabindex', '-1');
        });
        panels.forEach(p => p.classList.remove('active'));

        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
        tab.setAttribute('aria-expanded', 'true');
        tab.setAttribute('tabindex', '0');
        document.getElementById(tab.dataset.target)?.classList.add('active');

        if (focusTab) {
            tab.focus();
        }
    };

    menuTrigger.addEventListener('mouseenter', openMenu);

    // toggle on click — Enter/Space on the button trigger this natively
    menuTrigger.addEventListener('click', function () {
        dropdownItem.classList.contains('active') ? closeMenu() : openMenu();
    });

    dropdownExit.addEventListener('mouseenter', function () {
        menuCloseTimer = setTimeout(closeMenu, 150);
    });

    // immediate close when clicking the backdrop
    dropdownExit.addEventListener('click', closeMenu);

    dropdownNav.addEventListener('mouseenter', function () {
        clearTimeout(menuCloseTimer);
    });

    // hover, focus, and click all activate a category — focus is what makes
    // keyboard tabbing reveal the matching panel without an extra keystroke
    tabs.forEach(tab => {
        tab.addEventListener('mouseenter', () => activateTab(tab));
        tab.addEventListener('focus', () => activateTab(tab));
        tab.addEventListener('click', () => activateTab(tab));
    });

    // dropdown markup sits outside the <header> in the DOM, so natural Tab
    // skips past it — redirect Tab from the trigger into the active category
    menuTrigger.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab' || e.shiftKey) {
            return;
        }
        if (!dropdownItem.classList.contains('active')) {
            return;
        }
        e.preventDefault();
        const activeTab = tabs.find(t => t.classList.contains('active')) || tabs[0];
        activeTab?.focus();
    });

    // Shift+Tab from the active category returns to the trigger; arrow keys
    // cycle between categories with focus auto-activating the matching panel
    tabs.forEach((tab, idx) => {
        tab.addEventListener('keydown', (e) => {
            if (e.key === 'Tab' && e.shiftKey) {
                e.preventDefault();
                menuTrigger.focus();
                return;
            }

            let nextIdx = null;
            if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
                nextIdx = (idx + 1) % tabs.length;
            } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
                nextIdx = (idx - 1 + tabs.length) % tabs.length;
            } else if (e.key === 'Home') {
                nextIdx = 0;
            } else if (e.key === 'End') {
                nextIdx = tabs.length - 1;
            }
            if (nextIdx === null) {
                return;
            }
            e.preventDefault();
            activateTab(tabs[nextIdx], true);
        });
    });

    // escape closes and returns focus to the trigger
    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') {
            return;
        }
        if (!dropdownItem.classList.contains('active')) {
            return;
        }
        closeMenu();
        menuTrigger.focus();
    });

    // close when focus leaves the trigger and the dropdown
    document.addEventListener('focusin', (e) => {
        if (!dropdownItem.classList.contains('active')) {
            return;
        }
        if (menuTrigger.contains(e.target) || dropdownNav.contains(e.target)) {
            return;
        }
        closeMenu();
    });
}


/**************
 Mobile Nav
 ***************/

// mobile slider nested dropdown
document.querySelectorAll(".sliderNavDropdownToggle").forEach(element => {
    element.addEventListener("click", function () {
        this.classList.toggle("active");
    });
});

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("body").classList.add("noScroll");
}


// dialog close event
document.querySelector("#slider").addEventListener("close", async function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close nav
async function closeNav() {
    document.querySelector("#slider").close();
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#slider"));